import { render } from "./GeneticsProjRoute.vue?vue&type=template&id=49748740&scoped=true"
import script from "./GeneticsProjRoute.vue?vue&type=script&lang=js"
export * from "./GeneticsProjRoute.vue?vue&type=script&lang=js"

import "./GeneticsProjRoute.vue?vue&type=style&index=0&id=49748740&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49748740"]])

export default __exports__